// app/src/features/account/useCurrentEmail.ts

import { useEffect, useState } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

/**
 * Resolves the current user's email via Cognito's `fetchUserAttributes`.
 * Returns an empty string until the attributes are fetched.
 *
 * Caller passes `enabled` (typically `authStatus === 'authenticated'`) so
 * we don't fetch for signed-out users.
 */
export function useCurrentEmail(enabled: boolean): string {
  const [email, setEmail] = useState<string>('');

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void fetchUserAttributes()
      .then((attrs) => {
        if (cancelled) return;
        if (attrs.email) setEmail(attrs.email);
      })
      .catch(() => {
        // Best-effort; popover identity row falls back to "(no email)".
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return email;
}
